// extracted by mini-css-extract-plugin
module.exports = {"container":"score-module--container--2SFoC","item":"score-module--item--1SN8T","title":"score-module--title--VdhQS","valuation":"score-module--valuation--1ie1Y"};